<input type="text"
         [placeholder]="placeholder"
         nbInput
         [formControl]="control"
         [matAutocomplete]="auto"
         [status]="(control.invalid && control.touched) ? 'danger' : 'basic'"
         [fullWidth]="fullWidth"
         class="search-icon">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText" (optionSelected)='onSelectedOption($event.option.value)'>
    <mat-option *ngFor="let item of data" [value]="item">
      {{item.display}}
    </mat-option>
  </mat-autocomplete>
  <span [ngxAppValidationMessageFor]="control" class="error-message">
  </span>
